/**
 * useDraftSessionId – generate and persist a unique draft session ID.
 *
 * The ID is stored in sessionStorage so it survives hot-reloads and
 * tab refreshes but is discarded when the browser tab closes.
 *
 * Use this when uploading media before the owning entity (producer,
 * event, product …) has been created.
 */

import { useMemo } from 'react';

const PREFIX = 'farmly_draft_';

export function useDraftSessionId(key: string): string {
  return useMemo(() => {
    const storageKey = `${PREFIX}${key}`;
    const existing = sessionStorage.getItem(storageKey);
    if (existing) return existing;

    const id = crypto.randomUUID();
    sessionStorage.setItem(storageKey, id);
    return id;
  }, [key]);
}

/** Remove a stored draft session (call after finalize). */
export function clearDraftSessionId(key: string): void {
  sessionStorage.removeItem(`${PREFIX}${key}`);
}
